<template>
  <div class="game-info-navbar" :class="{ isPad: $padFalg != 'other' }">
    <div class="game-info-navbar-box">
      <div class="left-arrow" @click="callBack()"></div>
      <div class="box-title" v-if="useTitle">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    callBack: {
      type: Function,
      default: function () {
        this.$router.go(-1);
      }
    },
    width: {
      type: String,
      default: '7.5rem'
    },
    useTitle: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeCommunity() {
      window.pd.onBBSClose();
    }
  }
};
</script>

<style lang="scss" scoped>
.ipad {
  .game-info-navbar {
    max-width: 12.3rem;
    background-color: #ffffff;

    &-box {
      .left-arrow {
        background-image: url('../../../../../../assets/img/gl/top_left_return_black.png');
      }
    }
  }
}

.game-info-navbar {
  width: 100%;
  max-width: 7.5rem;
  height: 1.5rem;
  background-color: #21303b;
  color: white;
  font-size: 0.4rem;
  padding: 40px 0.2rem 0.2rem 0.2rem;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  z-index: 2;
  -webkit-user-select: none;
  .van-icon {
    position: absolute;
    right: 0;
  }
  &-box {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .left-arrow {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 0.21rem;
      height: 0.32rem;
      background-size: contain;
      background-image: url('../../../../../../assets/img/gl/top_left_return.png');
    }

    .box-title {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>